import {
  ConfigEntities,
  DisplayMagnitude,
  QtyBasisSources,
} from '@prisma/client';
import { object, z } from 'zod/v4';

export const quotingConfigCreateSchema = object({
  name: z.string().min(1, { error: 'Name can’t be blank' }),
  pricingConfigId: z.string().min(1, { error: 'Pricing config is required' }),
  costingConfigId: z.string().min(1, { error: 'Costing config is required' }),
});

export type QuotingConfigCreateDefaultFormValues = z.input<
  typeof quotingConfigCreateSchema
>;
export type QuotingConfigCreateFormData = z.output<
  typeof quotingConfigCreateSchema
>;

export const quotingConfigUpdateSchema = z.object({
  name: z.string().min(1, { error: 'Name can’t be blank' }),
  configEntityPriorities: z.array(z.enum(ConfigEntities)),
  basisQtySrc: z.array(z.enum(QtyBasisSources)),
  pricingConfigId: z.string(),
  costingConfigId: z.string(),
  daysUntilExpiration: z
    .int({ error: 'Must be an integer' })
    .min(0, { error: 'Days until expiration must be 0 or greater' }),
  daysUntilExpectedWin: z
    .int({ error: 'Must be an integer' })
    .min(0, { error: 'Days until expected win must be 0 or greater' }),
  quantityDisplayMagnitude: z.enum(DisplayMagnitude),
  discountCodeDefault: z.string().nullable(),
  marketCodeDefault: z.string().nullable(),
  defaultWonLossStatus: z.string().nullable(),
});

export type QuotingConfigUpdateDefaultFormValues = z.input<
  typeof quotingConfigUpdateSchema
>;
export type QuotingConfigUpdateFormData = z.output<
  typeof quotingConfigUpdateSchema
>;
